/* groups */
import Accordions from './accordions';
import Alert from './alert';
import Gallery from './gallery';
import Graph from './graph';
import Grid from './grid';
import Hero from './hero';
import Navigation from './navigation';
import Routing from './routing';
import SplitCallout from './split-callout';
import SplitOverlay from './split-overlay';
import SplitRouting from './split-routing';

/* singles */

import PreOrder from './preorder/script';
import Faqs from './faqs/script';

export default {
	...Accordions,
	...Alert,
	...Gallery,
	...Graph,
	...Grid,
	...Hero,
	...Navigation,
	...Routing,
	...SplitCallout,
	...SplitOverlay,
	...SplitRouting,
	...Faqs,

	[PreOrder.selector]: PreOrder
};
